import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/Auth";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const MemberPersonalDetails = ({ memberDetails }) => {
    const { requestWithAuth } = useAuth();
    const [updating, setUpdating] = useState(false);
    const [updateData, setUpdateData] = useState({});

  const handleFormChange = (e) => {
    setUpdateData({
      ...updateData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    if (memberDetails) {
      setUpdateData(memberDetails);
    }
  }, [memberDetails]);

  const maritalStatuses = [
    "Single","Married", "Divorced", "Remarried", "Co-Habitation"
  ]

  const updatePersonalDetails = async (e) => {
    e.preventDefault();
    setUpdating(true);
    try {
        const body = JSON.stringify(updateData);
        await requestWithAuth(
          `/members/${memberDetails.id}/`,
           "PUT",
            body,
            {
              "Content-Type": "application/json",
            },
          
        );
        Swal.fire({
            icon: "success",
            title: "Success!",
            text: "Personal details updated successfully.",
        }).then(()=>{
          window.location.reload();
        })
    } catch (error) {
        console.log(error);
        toast.error("Failed to update personal details. Please try again.");
    }finally{
        setUpdating(false);
    }
  }

  return (
    <form onSubmit={(e)=>updatePersonalDetails(e)} className="border border-gray-300 py-5 px-5">
      <div  className=" grid lg:grid-cols-3 gap-3">
        <div className="flex flex-col">
          <label htmlFor="" className="font-semibold">
            First Name *
          </label>
          <input
            name="first_name"
            type="text"
            onChange={handleFormChange}
            value={updateData.first_name || ""}
            required
            className="px-2 py-1 rounded border border-gray-200 "
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="" className="font-semibold">
            Last Name*
          </label>
          <input
            type="text"
            name="last_name"
            onChange={handleFormChange}
            value={updateData.last_name || ""}
            required
            className="px-2 py-1 rounded border border-gray-200 "
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="" className="font-semibold">
            Gender *
          </label>
          <select
            name="gender"
            id=""
            className="px-2 py-1 rounded border border-gray-200 "
            onChange={handleFormChange}
            required
          >
            <option selected={updateData?.gender == "Male"} value="Male">
              Male
            </option>
            <option selected={updateData?.gender == "Female"} value="Female">
              Female
            </option>
          </select>
        </div>
        <div className="flex flex-col">
          <label htmlFor="" className="font-semibold">
            Address *
          </label>
          <input
            type="text"
            name="address"
            onChange={handleFormChange}
            value={updateData.address || ""}
            required
            className="px-2 py-1 rounded border border-gray-200 "
          />
         
        </div>
        <div className="flex flex-col">
          <label htmlFor="" className="font-semibold">
            Phone Number *
          </label>
          <input
            type="text"
            name="phone_number"
            onChange={handleFormChange}
            value={updateData.phone_number || ""}
            required
            className="px-2 py-1 rounded border border-gray-200 "
          />
        
        </div>
        <div className="flex flex-col">
          <label htmlFor="" className="font-semibold">
            Email
          </label>
          <input
            type="email"
            name="email"
            onChange={handleFormChange}
            value={updateData.email || ""}
            
            className="px-2 py-1 rounded border border-gray-200 "
          />
          
        </div>
        <div className="flex flex-col">
          <label htmlFor="" className="font-semibold">
            Date of Birth
          </label>
          <input
            type="date"
            name="datge_of_birth"
            onChange={handleFormChange}
            value={updateData.date_of_birth || ""}
            className="px-2 py-1 rounded border border-gray-200 "
          />
          
        </div>
        <div className="flex flex-col">
          <label htmlFor="" className="font-semibold">
            Hometown
          </label>
          <input
            type="text"
            name="hometown"
            onChange={handleFormChange}
            value={updateData.hometown || ""}
            required
            className="px-2 py-1 rounded border border-gray-200 "
          />
          
        </div>
        <div className="flex flex-col">
          <label htmlFor="" className="font-semibold">
            Nationality
          </label>
          <input
            type="text"
            name="nationality"
            onChange={handleFormChange}
            value={updateData.nationality || ""}
            required
            className="px-2 py-1 rounded border border-gray-200 "
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="" className="font-semibold">
            Residence *
          </label>
          <input
            type="text"
            name="residence"
            onChange={handleFormChange}
            value={updateData.residence || ""}
            required
            className="px-2 py-1 rounded border border-gray-200 "
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="" className="font-semibold">
            Languages Spoken
          </label>
          <input
            type="text"
            name="languages_spoken"
            onChange={handleFormChange}
            value={updateData.languages_spoken || ""}
            className="px-2 py-1 rounded border border-gray-200 "
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="" className="font-semibold">
            Marital Status *
          </label>
          <select
            name="gender"
            id=""
            className="px-2 py-1 rounded border border-gray-200 "
            onChange={handleFormChange}
            required
          >
            {
                maritalStatuses.map((status) => (
                    <option
                    key={status}
                    selected={updateData?.marital_status == status}
                    value={status}
                    >
                    {status}
                    </option>
                ))
            }
            
          </select>
         
        </div>
        
      </div>
      <div className="flex items-center justify-end mt-2">
            <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors duration-200" disabled={updating}>
                Update Personal Details
            </button>
        </div>
    </form>
  );
};

export default MemberPersonalDetails;
